import { Container, Grid, Typography } from '@mui/material';

import { makeStyles } from '@mui/styles';
import { MetaTags } from 'components/common';

const useStyles = makeStyles(() => ({
  TermsServiceBg: {
    display: 'block',
    padding: '50px 0',

    '& h5': {
      fontSize: 12,
      marginBottom: '0px',
    },

    '& p': {
      fontSize: 11,
      marginBottom: '1rem',

      '& span': {
        fontWeight: 700,
      },
    },
  },
}));

function TermsService() {
  const classes = useStyles();

  return (
    <>
      <MetaTags
        title="Terms And Conditions - POD"
        description="Terms and conditions"
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="pod podworld terms and conditions"
      />
      <div className={classes.TermsServiceBg}>
        <Container maxWidth="lg">
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <h3>Terms and Conditions</h3>
              <Typography variant="body1">
                The Agreement: The use of this platform and services on this
                platform provided by Crowdpouch Ventures Services Private
                Limited (herein referred to as &quot;Owner&quot;) are subject to
                the following Terms and Conditions (hereinafter{' '}
                <b>&quot;Terms & Conditions&quot;</b>), all parts and subparts
                of which is are specifically incorporated by reference here
                together with the Privacy Policy and Disclaimer. Following are
                the <b>Terms & Conditions</b> governing your use of
                www.podworld.in (the <b>&quot;Platform&quot;</b>), all pages on
                the Platform and any services provided by or on its platform
                (&quot;Services&quot;).
              </Typography>

              <Typography variant="body1">
                By accessing either directly or through a hyperlink, the
                Platform and or purchasing from us, you engage in our “Service”
                and agree to be bound by the Terms & Conditions including those
                additional terms & conditions and policies referenced herein and
                or available by hyperlink. The Terms & Conditions apply to all
                users of the site, including without limitation to browsers,
                third-parties and contributors of content. You acknowledge and
                agree that the Platform may use your personal information in the
                manner described in our Privacy Policy which sets forth how
                information collected about you is collected, used and stored.
              </Typography>

              <h5>1. DEFINITIONS</h5>
              <Typography variant="body1">
                a) Owner, Us, We: The Owner, as the creator, operator of this
                Platform, makes the Platform and certain Services on it,
                available to users. Owner, Us, We, Our, Ours and other
                first-person pronouns will refer to the Owner, as well as the
                platform, all employees and affiliates of the Owner.
              </Typography>

              <Typography variant="body1">
                b) You, the User: you as the user of the Platform, will be
                referred throughout these Terms & Conditions with second-person
                pronouns such as You, Your, Yours, or as User. For the purpose
                of this Terms & Conditions, the term <span>“User”</span> or{' '}
                <span>“You”</span> shall mean any natural or legal person, who
                is accessing the Platform. The term <span>“Your”</span> shall be
                constructed accordingly.
              </Typography>

              <Typography variant="body1">
                c) Parties: Collectively, the parties to these Terms and
                Conditions (the Owner and You) will be referred to as Parties.
              </Typography>

              <h5>2. ASSENT AND ACCEPTANCE</h5>
              <Typography variant="body1">
                By using the Platform, You warrant that You have read and
                reviewed these Terms & Conditions and that you agree to be bound
                by it. If You do not agree to be bound by these Terms &
                Conditions, please leave the Platform immediately. We only agree
                to provide accessibility and use of this Platform and Services
                to You, if You assent to these Terms & Conditions. Furthermore,
                based on the Services obtained by You, additional terms and
                conditions (i.e Terms of Service) with respect to the specific
                service shall apply, which shall be deemed to be the agreement
                between You and Us.
              </Typography>

              <h5>3. ABOUT THIS SITE</h5>

              <Typography variant="body1">
                This is an online Platform which carries out fundraising. The
                use of this Platform and its services is not regulated under any
                law. We reserve the right to refuse the Service at our sole
                discretion to anyone, for any reason and at any time. You assume
                all risks associated with dealing with other users with whom you
                come in contact through this Platform. You agree to use this
                Platform for lawful purposes without infringing the rights or
                restricting the use of this Platform by any third-party.
              </Typography>

              <h5>4. ACCEPTABLE USE</h5>
              <Typography variant="body1">
                You agree to not use the Platform or Services for any unlawful
                purpose or in a way that could damage the Platform, Services and
                general business of the Owner.
              </Typography>

              <h5>5. AMENDMENTS</h5>

              <Typography variant="body1">
                We at our sole discretion from time to time may update and
                modify our Terms and Conditions without any notice to you. You
                agree that the Owner has the right to modify and amend the Terms
                & Conditions and it shall be in full force and effective
                immediately from the day the Terms & Conditions is updated or
                posted on the Platform and the amendments shall replace any
                previous version of the Terms & Conditions on the Platform.{' '}
                <br></br>
                Furthermore, you agree to routinely monitor these Terms &
                Conditions and refer to the Effective date posted at top of this
                Terms & Conditions to note amendments and modifications.
              </Typography>

              <h5>6. ASSUMPTION OF RISK</h5>
              <Typography variant="body1">
                The Platform and Services provided for information purposes
                only. You acknowledge and agree that any information posted on
                Our platform is not intended to be any sort of advice and no
                fiduciary relationship has been created between You and Us. You
                further agree that investment through POD is at your own risk.
                The Owner doesn’t assume responsibility and or liability for any
                information given on the Platform.
              </Typography>

              <h5>7. COMMUNICATION</h5>
              <Typography variant="body1">
                You understand that each time You use the Platform in any
                manner, you agree to these Terms & Conditions. By agreeing to
                these Terms & Conditions, you acknowledge that you are
                interested in availing the Services provided by the Platform and
                that you have selected and consent to receive communications via
                phone or e-mail from the Platform telling you about the Services
                offered by the Platform. You agree that the communication sent
                to you shall not be construed as spam or bulk under any law
                prevailing in any country where such communication is received.{' '}
              </Typography>

              <h5>8. DATA LOSS</h5>

              <Typography variant="body1">
                We do not accept responsibility for the security of your account
                or content. You agree that Your use of Platform and services are
                at Your own risk.
              </Typography>

              <h5>9. INDEMNIFICATION</h5>

              <Typography variant="body1">
                You agree to indemnify Us and any of our affiliates and hold Us
                harmless against any and all legal claims and demands (including
                attorney’s fees), which may arise from, or relate to Your use or
                misuse of the Platform and its Services, Your breach of Terms &
                Conditions or Your conduct or actions.
              </Typography>

              <h5>10. LICENSE TO USE PLATFORM</h5>

              <Typography variant="body1">
                We grant you limited, non-exclusive, non-transferable,
                non-sublicensable, revocable license to access, and make use of
                the services on the Platform. All rights not expressly granted
                to you in these Terms & Conditions, are reserved and retained by
                the Owner and its affiliates.
              </Typography>

              <Typography variant="body1">
                We may provide You with certain information as a result of Your
                use of the Platform or Services. Such information may include
                but is not limited to documents, data, or information of other
                registered users. You agree not to collect information of any
                sort of other Users from the Platform or download or copy any
                information by means of unsolicited access as to communicate
                directly with them or for any reason whatsoever.
              </Typography>

              <Typography variant="body1">
                Any unauthorized use by you shall terminate your access to the
                Platform. You agree that You shall not bypass any measures used
                by the Owner to prevent or restrict access to the Platform.
              </Typography>

              <h5>11. NO WARRANTIES</h5>

              <Typography variant="body1">
                You agree that the use of the Platform is at Your sole risk and
                the Platform is being made available to you on an “as is” and
                “as available” basis and it doesn’t provide any warranties,
                guarantees or conditions as to the usage being free from any
                faults, defects, interruptions, errors, viruses or to the
                accuracy, reliability, availability of content. You accept and
                understand that We shall not be held responsible for any
                interference or damage that may be caused to Your
                computer/device resource resulting in loss of your data from
                Your use of the Platform or Services. It is Your sole
                responsibility and We are not liable for any such loss and
                damages
              </Typography>
              <Typography variant="body1">
                Furthermore, We do not warrant that:
                <br></br>This Platform will be constantly available, or
                available at all; or
                <br></br>The information on this Platform is complete, true,
                accurate or non-misleading.
                <br></br>Nothing on the Platform constitutes or is meant to
                constitute, advice of any kind. All the Services provided on the
                Platform are unregulated.
              </Typography>

              <h5>12. OBLIGATION OF USERS</h5>
              <Typography variant="body1">
                As the User of the Platform or Services, you may be asked to
                register with Us. When you do so, You will choose a user
                identifier, which may be Your email address or another term, as
                well as a password. You will provide personal information not
                limited to Your name, email id, contact number etc. You shall be
                responsible for the accuracy of the information. This
                identifying information will enable You to use the Platform and
                its Services. You must not share such identifying information
                with any third-party. You agree to notify us immediately through
                an email, in case your identifying information has been
                compromised. You shall keep Us upraised in case of any changes
                in such information provided by You.
              </Typography>

              <h5>13. PAYMENT</h5>
              <Typography variant="body1">
                Should You register for any paid services in the Platform, You
                agree to pay us such specific monetary amount (“Fees”) for such
                Services on this Platform. Fees shall be payable through{' '}
                <a href="https://razorpay.com" target="_blank" rel="noreferrer">
                  https://razorpay.com
                </a>
                , whereby you&apos;ll be redirected to Razorpay&apos;s payment
                gateaway. For User registered as Investor, the money paid or
                invested shall be kept in a separate bank account, the Startup
                registered, on reaching the funding goal in the due timeline
                shall either issue You the share certificate or refund You your
                money. In case, the Startup doesn&apos;t reach the funding goal,
                the amount or money paid by you and kept in the separate bank
                account shall be refunded to your bank account.
              </Typography>

              <h5>14. PRIVACY</h5>
              <Typography variant="body1">
                We view protection of Your privacy as a very important
                principle. We understand clearly that You and Your Personal
                Information is one of Our most important assets. We store and
                process Your Information including any sensitive financial
                information collected (as defined under the Information
                Technology Act, 2000), if any, on computers that may be
                protected by physical as well as reasonable technological
                security measures and procedures in accordance with Information
                Technology Act, 2000 and Rules thereunder.
              </Typography>

              <Typography variant="body1">
                We may share personal information with our other corporate
                entities and affiliates registered with Us.
              </Typography>

              <Typography variant="body1">
                We may disclose personal information if required to do so by law
                or in the good faith that such disclosure is reasonably
                necessary to respond to subpoenas, court orders, or other legal
                process. We may disclose personal information to law enforcement
                offices, third-party rights owners, or others in the good faith
                that such disclosure is reasonably necessary to: enforce our
                Terms & Conditions or Privacy Policy; respond to claims that an
                advertisement, posting or other content violates the rights of a
                third party; or protect the rights, property or personal safety
                of our users or the general public.
              </Typography>

              <Typography variant="body1">
                We and our affiliates will share/sell some or all of your
                personal information with another business entity should we (or
                our assets) plan to merge with, or be acquired by that business
                entity, or reorganization, amalgamation, restructuring of
                business. Should such a transaction occur, another business
                entity (or the new combined entity) will be required to follow
                this privacy policy with respect to your personal information.
              </Typography>

              <h5>15. REVERSE ENGINEERING & SECURITY</h5>
              <Typography variant="body1">
                You agree not to undertake any of the following actions:
              </Typography>
              <Typography variant="body1">
                a) Reverse engineer or attempt to reverse engineer or
                disassemble any code or software from or on the Platform and
                Services.
              </Typography>
              <Typography variant="body1">
                b) Violate the security of the Platform or Services through any
                unauthorized access, circumvention of encryption or other
                security tool, data mining or interference to any host, user or
                network.
              </Typography>

              <h5>16. SPAM POLICY</h5>
              <Typography variant="body1">
                You are strictly prohibited from using Our Platform or any of
                Our Services for illegal spam activities, including gathering
                email addresses and personal information from others or sending
                any mass commercial emails.
              </Typography>

              <h5>17. SERVICE INTERRUPTION</h5>
              <Typography variant="body1">
                The Owner may need to interrupt Your access to this Platform to
                perform maintenance, development or any emergency services on
                scheduled or unscheduled basis. You agree Your access to the
                Platform may be affected by unanticipated or unscheduled
                downtime. We shall have no liability for any damage or loss
                occurred due to the shutdown.
              </Typography>

              <h5>18. THIRD-PARTY LINK & CONTENT</h5>
              <Typography variant="body1">
                The Owner may occasionally post third-party&apos;s website link
                or other services. You agree that the Owner shall not be held
                liable or responsible for any loss or damage as a result of Your
                use of any third-party&apos;s services linked to our Platform.
              </Typography>

              <h5>19. GENERAL PROVISION</h5>
              <Typography variant="body1">
                <span>a. Governing Law And Jurisdiction </span>
                <br></br>
                This Agreement shall be governed by and construed in accordance
                with the laws of India. In relation to any legal action or
                proceedings arising out of or in connection with this Agreement,
                each of the parties hereto hereby irrevocably submits to the
                exclusive jurisdiction of the courts of Bengaluru.
              </Typography>

              <Typography variant="body1">
                <span>b. Non Waiver</span>
                <br></br>
                The waiver or failure of either Party to exercise in any respect
                any right provided for in this Terms & Conditions shall not be
                deemed a waiver of any further right under this Terms &
                Conditions.
              </Typography>

              <Typography variant="body1">
                <span>c. Severability </span>
                <br></br>
                If any provision of this Terms & Conditions is deemed or held by
                a court of competent jurisdiction, to be contrary to law or
                otherwise unenforceable, it shall be enforced to the extent
                legally permissible and as necessary to reflect the intent of
                the Parties and shall not affect the remaining provisions of
                this Terms & Conditions , which shall remain in full force and
                effect.
              </Typography>

              <Typography variant="body1">
                <span>d. Entire Agreement </span>
                <br></br>
                This Terms & Conditions represents the entire understanding
                between the Parties with respect to the use of the Platform and
                subject matter herein and supersedes all prior agreements and
                understandings and writings of any kind, written or oral,
                expressed or implied, with respect to the subject matter hereof.
              </Typography>

              <Typography variant="body1">
                <span>e. Electronic Communication (Contact Information) </span>
                <br></br>
                Electronic communication via email is permitted to both the
                Parties under this Terms & Conditions. For any query and
                concerns, we request you to kindly email us at{' '}
                <span>
                  <a href="mailto:kanishk@crowdpouch.com">
                    kanishk@crowdpouch.com
                  </a>
                </span>{' '}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}

export default TermsService;
